import { createFeatureSelector, createSelector } from '@ngrx/store';

import { MilkDeliveryState } from '../../models/milk-delivery.model';

export const getMilkDeliveryState = createFeatureSelector<MilkDeliveryState>('milk-delivery');

export const getMilkDeliverySummary = createSelector(
  getMilkDeliveryState,
  (state: MilkDeliveryState) => state?.milkDeliverySummary,
);

export const getMilkDeliveryMonthSummary = createSelector(
  getMilkDeliveryState,
  (state: MilkDeliveryState) => state?.milkDeliveryMonthSummary,
);
